import React, { Component } from 'react';
import withStyles from 'react-jss';
import styles from './styles.js';
import logo from './logo.svg';
import pbb from './pbb-white.svg';

class Navbar extends Component {
	render() {
		const { classes, login } = this.props;
		return (
			<>
				<div className={classes.navbar}>
					<a className={classes.btnAnchor} href="/">
						<img src={logo} alt="" />
					</a>
					<div className={classes.btnLogo}>
						{login
							? (
								<a href="https://pyro.bquate.com/login">
									<button className={classes.login}>LOGIN</button>
								</a>
							)
							: ''}
						<img src={pbb} alt="" className={classes.pbb} />
					</div>
				</div>
			</>
		);
	}
}

export default withStyles(styles)(Navbar);
